module.exports = __webpack_public_path__ + "img/star-wand-icon.f189a3e3.svg";